import { DynamicDCAComponentProvider } from '@marriott/mi-headless-utils';
import { MerchandisingHeroBanner as HeroBanner } from './organisms/MerchandisingHeroBanner';
import {
  MerchandisingSmallBanner as SmallBanner,
  MerchandisingSmallBannerComponent as SmallBannerNonEditable,
} from './organisms/MerchandisingSmallBanner';
import {
  MerchandisingTileSkinny as TileSkinny,
  MerchandisingTileSkinnyComponent as TileSkinnyNonEditable,
} from './organisms/MerchandisingTileSkinny';
import {
  MerchandisingCardTile as CardTile,
  MerchandisingCardTileComponent as CardTileNonEditable,
} from './organisms/MerchandisingCardTile';
import {
  MerchandisingSerpBanner as Serpbanner,
  MerchandisingSerpBannerComponent as SerpbannerNonEditable,
} from './organisms/MerchandisingSerpBanner';
import {
  MerchandisingMangoPilot as MangoPilot,
  MangoPilotComponent as MangoPilotNonEditable,
} from './organisms/MangoPilot';
import {
  MerchandisingPortalModal as PortalModal,
  MerchandisingPortalModalComponent as PortalModalNonEditable,
} from './organisms/MerchandisingPortalModal';
import { SkeletonLoaderStyles } from './skeleton-loader.styles';

export const MerchandisingHeroBanner = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={HeroBanner} props={props} />;
};

export const MerchandisingSmallBanner = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={SmallBanner} props={props} />;
};

export const MerchandisingSmallBannerNonEditable = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={SmallBannerNonEditable} props={props} />;
};

export const MerchandisingTileSkinny = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={TileSkinny} props={props} />;
};

export const MerchandisingTileSkinnyNonEditable = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={TileSkinnyNonEditable} props={props} />;
};

export const MerchandisingCardTile = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={CardTile} props={props} />;
};

export const MerchandisingCardTileNonEditable = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={CardTileNonEditable} props={props} />;
};

export const MerchandisingSerpBanner = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={Serpbanner} props={props} />;
};

export const MerchandisingSerpBannerNonEditable = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={SerpbannerNonEditable} props={props} />;
};

export const MerchandisingMangoPilot = (props: unknown) => {
  return (
    <SkeletonLoaderStyles>
      <DynamicDCAComponentProvider Component={MangoPilot} props={props} />
    </SkeletonLoaderStyles>
  );
};

export const MerchandisingMangoPilotNonEditable = (props: unknown) => {
  return (
    <SkeletonLoaderStyles>
      <DynamicDCAComponentProvider Component={MangoPilotNonEditable} props={props} />
    </SkeletonLoaderStyles>
  );
};

export const MerchandisingPortalModal = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={PortalModal} props={props} />;
};

export const MerchandisingPortalModalNonEditable = (props: unknown) => {
  return <DynamicDCAComponentProvider Component={PortalModalNonEditable} props={props} />;
};
